var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layout"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    ref: "loader",
    staticClass: "layout__loader",
    class: {
      layout__loader_show: _vm.hasNextPage
    }
  }, [_c('img', {
    staticClass: "layout__loading",
    attrs: {
      "src": require("./asset/loading.svg"),
      "alt": "загрузка"
    }
  })])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }